import { ReactNode } from "react";

/** A sign-in screen's heading: what this step is, and one line on what to do. */
export const AuthHead = ({ title, children }: { title: ReactNode; children?: ReactNode }) => (
  <div className="erp-auth-head">
    <h1>{title}</h1>
    {children ? <p className="text-body-secondary mb-0">{children}</p> : null}
  </div>
);

/** The links under a sign-in form (forgot password, start a trial, back to sign in). */
export const AuthLinks = ({ children }: { children: ReactNode }) => (
  <div className="erp-auth__links">{children}</div>
);
